module.exports = __webpack_public_path__ + "static/media/ticket-less.3a093561.png";